'use client';

import type { ParentOrderInfo } from 'src/@types/historyTables';
import NumberDisplay from 'src/components/NumberDisplay/NumberDisplay';
import type { AmountDisplayType } from '../TradePageOrderHistoryTable';
import { PRESETS } from 'src/utils/formatNumber/presets';

interface FilledSizeCellProps {
	order: ParentOrderInfo;
	amountDisplayType: AmountDisplayType;
}

export function FilledSizeCell({
	order,
	amountDisplayType,
}: FilledSizeCellProps) {
	const { baseAssetAmountFilled, quoteAssetAmountFilled } = order;

	if (amountDisplayType === 'base') {
		return (
			<NumberDisplay
				value={baseAssetAmountFilled}
				options={PRESETS.tradePrecisionTrim}
				isAccountValueToHide
			/>
		);
	}

	return (
		<NumberDisplay
			value={quoteAssetAmountFilled}
			options={PRESETS.usd}
			isAccountValueToHide
		/>
	);
}
